import React, { useCallback, useState, useEffect } from 'react';
import {
  makeStyles,
  Paper,
  Button,
  Grid,
  TextField,
  Fade,
  LinearProgress,
  Divider,
} from '@material-ui/core';
import { NotificationManager } from 'react-notifications';

import PageTitle from '../components/PageTitle/PageTitle';
import useUser from '../hooks/useUser';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  grow: {
    flexGrow: 1,
  },
  checkbox: {
    maxWidth: 280,
    display: 'flex',
    '& .MuiFormControlLabel-label': {
      flexGrow: 1,
    },
  },
}));

function ProfilePage() {
  const classes = useStyles();
  const [user, updateUser] = useUser();
  const [userData, setUserData] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setUserData(user);
  }, [user]);

  const handleUserData = useCallback(
    (fieldName) => (e) => {
      setUserData({ ...userData, [fieldName]: e.target.value });
    },
    [userData],
  );

  const onUpdate = useCallback(async () => {
    setLoading(true);
    const result = await updateUser({ ...userData });
    if (result) {
      NotificationManager.success('Success');
    } else {
      NotificationManager.error('Failed');
    }
    setLoading(false);
  }, [updateUser, userData]);

  return (
    <>
      <div className={classes.titleContainer}>
        <PageTitle title="Profile" />
      </div>
      <Fade in={isLoading}>
        <LinearProgress variant="query" />
      </Fade>
      <Paper style={{ padding: '40px 20px 20px', maxWidth: 700 }}>
        {userData && (
          <Grid container direction="column" spacing={4}>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="first-name"
                  label="First name"
                  value={userData.firstname || ''}
                  onChange={handleUserData('firstname')}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="last-name"
                  label="Last name"
                  value={userData.lastname || ''}
                  onChange={handleUserData('lastname')}
                />
              </Grid>
            </Grid>

            <Grid item>
              <Divider />
            </Grid>
            <Grid item container spacing={2} justify="center">
              <Button color="primary" variant="contained" onClick={onUpdate}>
                Update
              </Button>
            </Grid>
          </Grid>
        )}
      </Paper>
    </>
  );
}

export default ProfilePage;
